(() => {
  function hideExpiredNotices() {
    const now = Date.now() / 1000;
    document.querySelectorAll('[data-tr-holiday]').forEach((notice) => {
      const end = Number(notice.dataset.holidayEnd);
      if (end > 0 && now >= end) {
        if (notice instanceof HTMLDialogElement && notice.open) notice.close();
        notice.hidden = true;
      }
    });
  }

  function initializeNotices() {
    hideExpiredNotices();
    document.querySelectorAll('.tr-holiday-dialog:not([data-initialized])').forEach((dialog) => {
      dialog.dataset.initialized = 'true';
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      ['keydown', 'keyup'].forEach((name) => dialog.addEventListener(name, (event) => {
        if (event.key === 'Escape') event.stopPropagation();
      }));
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tr-holiday-open]');
    if (trigger) {
      const dialog = document.getElementById('tr-holiday-dialog');
      hideExpiredNotices();
      if (dialog && !dialog.hidden && !dialog.open) dialog.showModal();
    }
    const close = event.target.closest('[data-tr-holiday-close]');
    if (close) close.closest('dialog')?.close();
  });
  document.addEventListener('shopify:section:load', initializeNotices);
  document.addEventListener('visibilitychange', hideExpiredNotices);
  window.addEventListener('pageshow', hideExpiredNotices);
  window.setInterval(hideExpiredNotices, 60000);
  initializeNotices();
})();
